<template>
  <div>
    <v-container class="pt-0">
    <v-layout wrap>
      <v-flex xs12 class="ma-2">
        <div class="text-sm-left f-20" color="#002d4a">Class view (class title)</div>
      </v-flex>
      <v-divider></v-divider>
    </v-layout>
      <v-card class="grey lighten-3 mt-2 card-r no-shadow ">
        <v-btn icon to="/classes">
          <v-icon color="grey">keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn icon flat color="grey" to="/confirmdelete" class="text-xs-right right"><v-icon >delete</v-icon></v-btn>
        <v-btn icon flat color="grey" to="/createclass" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>
      </v-card>

      <v-layout xs12>
        <v-flex xs12 offset-xs0 class="">
          <v-carousel  height="300"
                       class="card-r no-shadow mt-2" width="300" alt="alt text" style="float: left">
            <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
        </v-flex>
      </v-layout>

      <v-card class="grey lighten-3 no-shadow card-r mt-2">
        <v-flex xs12 offset-xs0 class="ml-3 mr-3">
          <div class="f-25 font-weight-bold textColor mt-2">Class Title</div>
        </v-flex>
        <v-layout xs12>
          <v-flex xs12 offset-xs0 class="ml-3 mr-3">
            <span class="f-15 font-weight-bold text--darken-1 ">Price : - </span>
            <span class="f-15 font-weight-bold text--darken-1 ">$ 450</span>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs12 offset-xs0 class="text-xs-left ml-3">
            <span class="f-15 font-weight-bold text--darken-1">Hours : - </span>
            <span class="f-15 font-weight-bold text--darken-1">xxx h</span>
          </v-flex>
        </v-layout>
        <v-layout xs12 class="ml-3 mr-3 mt-2">
          <v-flex xs12>
            <div class="f-20 font-weight-bold mt-2">Description of this class</div>
            <p v-for="(n, index) in 3">Lorem ipsum dolor sit am et, consectetur adipisicing elit.
              Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto,
              Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto,
              Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto,
              Harum maiores modi quidem veniam, expedita quis laboriosam, ullam facere adipisci, iusto,
              voluptate sapiente corrupti asperiores rem nemo numquam fuga ab at.</p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'Viewclass',
    data () {
      return {
        TcoverPhoto: "https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg",
        TProfileImg: "https://adayinthelifeimages.com/wp-content/uploads/2016/05/brisbane-headshots-commercial-photography-09.jpg",
        items : [
          {
            src: 'http://www.thedailytruffle.com/wp-content/uploads/2011/11/mercedes-benz-driving-school-teenagers-los-angeles-3.jpg'
          },
          {
            src: 'http://www.amgdrivingacademy.co.za/media/1194/gvw_5772.jpg'
          },
          {
            src: 'https://i.ytimg.com/vi/Vxekzd2lcfg/maxresdefault.jpg'
          },
          {
            src: 'https://d3lp4xedbqa8a5.cloudfront.net/imagegen/max/ccr/1023/-/s3/digital-cougar-assets/whichcar/2015/11/27/-1/Volvo-V40-driving-course.jpg'
          }
        ]
      }
    }
  }
</script>

<style>
  .v-carousel__next .v-btn i, .v-carousel__prev .v-btn i{
    font-size: 24px !important;
  }
  .v-carousel__controls{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pages/classes/Viewclass.vue